// components


const Layout = ({ children }) => {
  return (
    <>
      {/* <Menu /> */}
      <>
			{children}
			</>

    </>
  );
};

export default Layout;
